import config from 'Cloud/config';
import { APIConfig } from 'reactApp/api/APIConfig';

APIConfig.set('user', config.get('user.email'));
APIConfig.set('csrf-token', config.get('tokens.csrf'));
APIConfig.set('x-page-id', config.get('x-page-id'));
APIConfig.set('auth-domain', config.get('AUTH_DOMAIN'));
